module.exports = __webpack_public_path__ + "img/A.ebf83920.png";